import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 0;
`;

export default Wrapper;